<template>
    <div :class="loggedin ? 'main loggedin site-wrapper' : 'main guest site-wrapper'">
        <div class="product-reg-template">
            <template v-if="loggedin">
                <superadmin-sidebar v-if="userrole == 'superadmin'" />
                <distributor-sidebar v-if="userrole == 'distributor'" />
                <reseller-sidebar v-if="userrole == 'reseller'" />
                <customer-sidebar v-if="userrole == 'customer'" />
            </template>

            <section :class="'reg-temp-v2-main ' + (loggedin ? '' : 'guest')">
                <template v-if="loggedin">
                    <superadmin-breadcrumb v-if="userrole == 'superadmin'" />
                    <distributor-breadcrumb v-if="userrole == 'distributor'" />
                    <reseller-breadcrumb v-if="userrole == 'reseller'" />
                    <customer-breadcrumb v-if="userrole == 'customer'" />
                </template>

                <!-- <transition :name="transitionName" :duration="{ enter: 3000, leave: 0 }"> -->
                <!-- slide-fade slide-right-->
                <router-view></router-view>
                <!-- </transition> -->
            </section>
        </div>
        <spinner></spinner>
        <logoutspinner></logoutspinner>
        <snackbar></snackbar>
        <app-pdf-viewer></app-pdf-viewer>
        <vue-confirm-dialog class="my-return-confirm"></vue-confirm-dialog>
    </div>
</template>

<script>
import Env from '@/env';
import TransitionPage from '@/transitions/TransitionPage.vue';
import {mapGetters, mapActions} from 'vuex';
import AuthApis from '@/controllers/AuthApis';

export default {
    name: 'MainApp',
    components: {
        TransitionPage
    },
    data() {
        return {
            duration: {},
            transitionName: 'fade'
        };
    },
    computed: {
        ...mapGetters({
            loggedin: 'auth/token',
            user: 'auth/user'
        }),
        userrole() {
            return this.user.role;
        }
    },
    watch: {
        $route(to, from) {
            if (from.name == '' || from.name == 'Login') {
                this.transitionName = 'fade';
            } else if (to.name == 'Login') {
                this.transitionName = 'fade';
            } else {
                this.transitionName = 'slide-right';
            }
        }
    },
    mounted() {
        this.spinner(false);
        this.logoutspinner(false);
        if (this.user && this.user.id) {
            this.fetchProductCodes();
        }
    },
    methods: {
        /**
         * resync product codes
         */
        fetchProductCodes() {
            const url = `${Env.baseUrl}/auth/fetch-product-with-code`;
            AuthApis.getApi(url)
                .then(async (res) => {
                    this.va_setMainProduct(res.data.payload);
                    this.va_setMainProductGroup(res.data.grouped);
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        ...mapActions({
            va_setMainProduct: 'mainproduct/setMainProduct',
            va_setMainProductGroup: 'mainproduct/setMainProductGroup'
        })
    }
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Hind:wght@300;400;500;600;700&display=swap');
</style>
